// eslint-disable-next-line no-redeclare, @typescript-eslint/no-redeclare
import { Text } from '@mantine/core';
import { FC } from 'react';
import moment from 'moment';
import { BookitupNotification } from '../../../../Types/LogT';
import { RoutingS } from '../../../../Service/RoutingS';
import LinkText from '../../../../Atoms/LinkText';

const ContractSigned: FC<{ notification: BookitupNotification }> = ({ notification }) => {
  const { eventId, eventDate, personDescription } = notification;

  return (
    <Text>
      Vertrag zum{'  '}
      <LinkText span weight="bolder" onClick={() => RoutingS.openInNewTab(`/events/${eventId}/details`)}>
        Event
      </LinkText>
      {'  '}von
      <Text span weight="bolder">
        {` ${personDescription}`}
      </Text>
      {eventDate && (
        <>
          {'  '}am
          <Text span weight="bolder">
            {` ${moment(eventDate).format('LL')}`}
          </Text>
        </>
      )}
      {'  '}wurde unterschrieben.
    </Text>
  );
};

export default ContractSigned;
